import { Component, createRef } from 'preact'
import { copyToClipboard } from '../../utils/copy-to-clipboard'
import { __ } from '../../../locales'

class CopyButton extends Component {
    constructor (props) {
        super(props);

        this.successMessageRef = createRef()
        this.textRef = props.textRef
    }

    copyCode = () => {
        copyToClipboard(this.textRef?.current)
        this.successMessageRef.current.style.visibility = 'visible'
        setTimeout(() => {
            this.successMessageRef.current.style.visibility = 'hidden'
        }, 3000) // 3sec
    }

    render(props, state, context) {
        return (
            <div className={'copy-button'} onClick={this.copyCode}>
                <div ref={this.successMessageRef} className={'copy-button-success'}>
                    {__('global.copied')}
                </div>
            </div>
        );
    }
};

export default CopyButton;
